import { Route, Switch, Redirect, BrowserRouter } from "react-router-dom";
import { getAuth } from "firebase/auth";

import AuthLayout from "layouts/Auth";
import AdminLayout from "layouts/Admin";
import { useContext, useEffect } from "react";
import { UserContext } from "context/user.context";
import SpinnerApp from "components/Spinner/SpinnerApp";
import { getLoggedUser } from "service/user.service";

export default function App() {
  const [user, setUser] = useContext(UserContext);

  const getUser = async () => {
    setUser({ user: null, loading: true, error: null });
    try {
      const loggedUser = await getLoggedUser();
      setUser({ user: loggedUser.data, loading: false, error: null });
    } catch (error) {
      // throw error
      console.log(error);
      setUser({ user: null, loading: false, error: "fail" });
    }
  };

  useEffect(() => {
    const auth = getAuth();

    let refreshTokenInterval = null;
    const updateToken = async (fireUser) =>
      sessionStorage.setItem("idToken", await fireUser.getIdToken());
    const token = sessionStorage.getItem("idToken");

    if (auth.currentUser) {
      updateToken(auth.currentUser);
    }

    auth.onAuthStateChanged((currentUser) => {
      refreshTokenInterval = setInterval(async () => {
        console.log("Interval");
        const newToken = await currentUser.getIdToken();

        sessionStorage.removeItem("idToken");
        sessionStorage.setItem("idToken", newToken);
      }, 57 * 60 * 1000 );
    });
    if (token && !user.user) {
      getUser();
    }
    return () => {
      clearInterval(refreshTokenInterval);
      console.log("Interval clean");
    };
  }, []);

  return (
    <SpinnerApp show={user.loading}>
      {(user && user.user) || sessionStorage.getItem("idToken") ? (
        <BrowserRouter>
          <Switch>
            <Route path={`/admin`} component={AdminLayout} />
            {/* <Route path={`/admin`} component={()=><div>test</div>} /> */}
            <Redirect from={`/`} to="/admin/dashboard" />
          </Switch>
        </BrowserRouter>
      ) : (
        <BrowserRouter>
          <Switch>
            <Route path={`/auth`} component={AuthLayout} />
            <Redirect from={`/`} to="/auth/signin" />
          </Switch>
        </BrowserRouter>
      )}
    </SpinnerApp>
  );
}
